/**
 * SafeImage — renders a product image with a graceful catalog-clean
 * placeholder when the underlying URL fails to load (e.g. the file was
 * lost to K8s ephemeral storage on redeploy). One bad image must never
 * blank a card or a PDP.
 *
 * Drop-in for <img> on the storefront image surfaces. Preserves srcSet,
 * sizes, alt text and Tailwind classNames passed in.
 */
import React, { useState } from "react";
import { ImageOff } from "lucide-react";

export default function SafeImage({ src, srcSet, sizes, alt, className, fallbackLabel, ...rest }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        data-testid="safe-image-fallback"
        className={(className || "") + " flex flex-col items-center justify-center text-zinc-400 bg-white"}
      >
        <ImageOff size={28} strokeWidth={1.4} />
        <span className="mt-2 text-[10px] uppercase tracking-[0.25em] font-bold px-3 text-center text-zinc-500 leading-snug">
          {fallbackLabel || "Image coming soon"}
        </span>
      </div>
    );
  }
  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
